export class CostReviewFireEnUsSystemConfiguration {
  isSystemConfigurationApplicableLessThanThreshold!: boolean;
  isSystemConfigurationApplicable!: boolean;
  desigoPanels!: number[];
  voiceSystem!: number;
  globalVoice!: number;
  backupAmps!: number[];
  batteryBackup!: number;
  nacWiring!: number;
  idcWiring!: number;
  slcWiring!: number;
  proposedSystem!: number;
  dialerProvidedBySiemens!: number;
  communicationMethod!: number;
  mxlvDesigoFsmMigration!: number;
  numberOfNodes!: number;
  networkStyle!: number;
  networkOptions!: number[];
}
